export default "__VITE_ASSET__BzygEjZ5__"